import Add16 from '@carbon/icons-react/es/add/16';
import { Col, Form, Row } from 'antd';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Input } from 'components/atoms/input';
import { toastService } from 'components/molecules/toast';
import { useTranslation } from 'hooks/use-translation';

const StyledForm = styled(Form)`
  margin-top: var(--spacing-05);
`;

const StyledCol = styled(Col)`
  height: 40px;
`;

export const SalesforceLinkObject = ({
  handleSubmit,
  onClose,
  setErrorState,
  errorState,
  error,
}) => {
  const placeholderText = useTranslation(
    'project.overview.past_a_salesforce_object',
  );
  const saveText = useTranslation('project.overview.link_salesforce_object');
  const validationMessage = useTranslation('input.url');
  const cancelText = useTranslation('cancel');
  const failMessage = useTranslation(
    'project.overview.cant_link_salesforce_object',
  );

  const [form] = Form.useForm();

  const handleLink = async () => {
    const { issueUrl } = await form.validateFields();

    handleSubmit(issueUrl);
  };

  useEffect(() => {
    if (errorState) {
      toastService({
        title: failMessage,
        message: error,
      }).error();
    }
  }, [errorState, error, failMessage]);

  const cancelFunc = (props) => {
    onClose(props);
    setErrorState('');
  };

  return (
    <StyledForm form={form} onValuesChange={() => setErrorState('')}>
      <Row justify="end" gutter={[16, 16]}>
        <Col span={24}>
          <Form.Item
            name="issueUrl"
            rules={[
              { type: 'url', message: validationMessage },
              {
                required: true,
                message: ' ',
                whitespace: true,
              },
            ]}
          >
            <Input placeholder={placeholderText} autoFocus />
          </Form.Item>
          {/* {!!errorState && <ErrorMessage>{validationMessage} </ErrorMessage>} */}
        </Col>
        <StyledCol>
          <Button onClick={cancelFunc}>{cancelText}</Button>
        </StyledCol>
        <StyledCol>
          <Form.Item shouldUpdate>
            {() => (
              <Button
                disabled={
                  !form.isFieldsTouched(true) ||
                  !!form.getFieldsError().filter(({ errors }) => errors.length)
                    .length
                }
                onClick={handleLink}
                icon={<Add16 />}
                type="primary"
                iconPlacement="right"
                htmlType="submit"
              >
                {saveText}
              </Button>
            )}
          </Form.Item>
        </StyledCol>
      </Row>
    </StyledForm>
  );
};
